module.exports = __webpack_public_path__ + "img/item-5.70d3674.png";